import { Routes, Route } from 'react-router-dom';
import './App.css';
import PageNotFound from './Components/PageNotFound';
import ClaraViewFlow from './Components/ClaraView';
import LandingPage from './Components/ClaraView/LandingPage';
import ClaraViewErrorBoundary from './Components/ClaraView/ErrorBoundary';
import RequireMobile from './Components/ClaraView/RequireMobile';
import RequirePortrait from './Components/ClaraView/RequirePortrait';
import Unsubscribe from './Components/Unsubscribe';
import DentistView from './Components/DentistView';
import OnboardingConsume from './Components/OnboardingConsume';
import { DashboardHome } from './Dashboard'; // Re-added Patients, Messages
// import NewDashboard from './Dashboard/newDashboard';
import Login from './Dashboard/Auth/Login';
import SignUp from './Dashboard/Auth/SignUp';
import OtpVerification from './Dashboard/Auth/OtpVerification';
import ForgotPassword from './Dashboard/Auth/ForgotPassword';
import ResetPassword from './Dashboard/Auth/ResetPassword';
import NewPassword from './Dashboard/Auth/NewPassword';
import Subscription from './Dashboard/Subscription/Subscription';
import SubscriptionPending from './Dashboard/Subscription/SubscriptionPending';
import BillingUpdateCard from './Dashboard/Subscription/BillingUpdateCard';
import Onboarding from './Dashboard/Onboarding';
import AuthProtectedDashboardRoute from './Components/ProtectedRoutes/AuthProtectedDashboardRoute';
import FunnelGate from './Components/ProtectedRoutes/FunnelGate';
import { SnackbarProvider } from './Context/SnackbarContext';
import { SocketProvider } from './Context/SocketContext';

const App = () => {

    return (
        <SnackbarProvider>
            <div className="App">
                <Routes>
                    {/* Shared / device-agnostic */}
                    <Route path="/unsubscribe/:id" element={<Unsubscribe />} />
                    <Route path="/dentist-view/:uid/:imageName" element={<DentistView />} />
                    <Route path="/smile-virtual/onboard" element={<OnboardingConsume />} />

                    {/* Dashboard — public (accessible only when NOT logged in) */}
                    <Route element={<AuthProtectedDashboardRoute isLoggedInPage={false} />}>
                        <Route path="/login" element={<Login />} />
                        <Route path="/signup" element={<SignUp />} />
                        <Route path="/otp-verification" element={<OtpVerification />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                        <Route path="/new-password" element={<NewPassword />} />
                    </Route>

                    {/* Dashboard — protected (accessible only when logged in) */}
                    <Route element={<AuthProtectedDashboardRoute isLoggedInPage={true} />}>
                        <Route path="/subscription" element={<SubscriptionPending />} />

                        <Route element={<FunnelGate />}>
                            <Route path="/pricing" element={<Subscription />} />
                            <Route path="/billing/update-card" element={<BillingUpdateCard />} />
                            <Route path="/onboarding" element={<Onboarding />} />
                            <Route
                                path="/dashboard/*"
                                element={
                                    <SocketProvider>
                                        <DashboardHome />
                                    </SocketProvider>
                                }
                            />
                        </Route>
                    </Route>

                    {/* ClaraView — gated to mobile + portrait */}
                    <Route
                        path="/:userName"
                        element={
                            <RequireMobile>
                                <RequirePortrait>
                                    <ClaraViewErrorBoundary><LandingPage /></ClaraViewErrorBoundary>
                                </RequirePortrait>
                            </RequireMobile>
                        }
                    />
                    <Route
                        path="/claraview/*"
                        element={
                            <RequireMobile>
                                <RequirePortrait>
                                    <ClaraViewFlow />
                                </RequirePortrait>
                            </RequireMobile>
                        }
                    />

                    {/* Fallback */}
                    <Route path="*" element={<PageNotFound />} />
                </Routes>
            </div>
        </SnackbarProvider>
    );
}

export default App;
